import { getScrubInvocationDetails } from "../api/ScrubInvocationDetailsAPI";


export const initialButtonState = {
    items: [],
    loading: false
}

export const ScrubInvocationDetailsReducer = (state, action) => {
    switch (action.type) {
        case "START_SCRUB":
            const {scrubType, dispatcher} = action.data;
            getScrubInvocationDetails({scrubType}, dispatcher);
            return {...initialButtonState, loading: true }
        case "SET_DATA":
            return { ...state, items: action.data, loading: false }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/commons/reducer/ScrubInvocationDetailsReducer.js